import React, { Component } from 'react';
import { Group, Stage, Layer, Rect, Line} from 'react-konva';

class LFOWaveform extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pts: [],
        };

        this.oldData = [];
        this.width = 200;
        this.height = 40;
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            if (this.props.isSelected) {
                let data = this.props.lfo.meter.getValue()
                this.setState({pts: this.getPoints(data)});
            }
        }, 100);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    getPoints(data) {
        let arrayLen = 64;
        let dataArray = new Int8Array(arrayLen);
        let pts = [];
        
        let len = 8;
        dataArray.set(data, 0, len);
        if (this.oldData.length === 0) {
        } else {
            dataArray.set(this.oldData.subarray(0, arrayLen-len+2), len-2);
        }

        data  = dataArray;

        for (let i in data) {
            let dataPt = data[i];
            let x = Math.floor(this.width * i / data.length);
            let max = this.height;
            let min = 0;
            let height = (max - min) * (dataPt + 100) / 200 + min;
            let y = 0;
            pts.push({
                x: x,
                y: this.height - height,
                height: height,
                width: 3
            });
        }
        this.oldData = data;
        return pts;
    }

    render() {
        if (!this.props.isSelected) {
            return (
                <div></div>
            );
        }
        return (
            <div className="lfo-waveform">
              <Stage
                width={this.width}
                height={this.height}
                >
                <Layer>
                  {this.state.pts.map(
                    (pt) =>
                      <Rect
                        x={pt.x}
                        y={pt.y}
                        width={pt.width}
                        height={pt.height}
                        fill={'red'}/>)}
 
                </Layer>
              </Stage>
            </div>
        );
    }
}

export default LFOWaveform;
